export default {
  ["agent_admin"]: `หลังบ้านตัวแทน`,
  ["edit_pwd"]: `เปลี่ยนรหัสผ่าน`,
  ["logout"]: `ออกจากระบบ`,
  ["login"]: `เข้าสู่ระบบ`,
  ["register"]: `สมัครสมาชิก`,
  ["dashboard"]: `แดชบอร์ด`,
  ["registration"]: `ลิงก์สมัครสมาชิก`,
  ["incomes"]: `ปันผล`,
  ["record"]: `บันทึก`,
  ["rules"]: `กฎ`,
  ["account"]: `บัญชี`,
  ["account_ph"]: `กรุณากรอกบัญชีให้ถูกต้อง`,
  ["password"]: `รหัสผ่าน`,
  ["password_ph"]: `กรุณากรอกรหัสผ่านให้ถูกต้อง`,
  ["remember_account"]: `จำบัญชี`,
  ["invite_ratio"]: `เชิญผู้เล่นเพื่อรับ`,
  ["invite_ratio_desc"]: `กำไรขาดทุนสุทธิ`,
  ["product_fee_ratio"]: `ค่าธรรมเนียมผลิตภัณฑ์`,
  ["product_fee_ratio_desc"]: `กำไรขาดทุนสุทธิ`,
  ["register_count"]: `จำนวนผู้สมัคร`,
  ["login_count"]: `จำนวนผู้เข้าสู่ระบบ`,
  ["deposit_count"]: `จำนวนผู้เติมเงิน`,
  ["first_deposit_count"]: `จำนวนผู้เติมครั้งแรก`,
  ["deposit_amount"]: `ยอดเติมเงิน`,
  ["withdraw_amount"]: `ยอดถอนเงิน`,
  ["valid_bet_amount"]: `ยอดเดิมพันที่มีผล`,
  ["win_amount"]: `ยอดเงินรางวัล`,
  ["bonus_amount"]: `โบนัสกิจกรรม`,
  ["profit_amount"]: `กำไรขาดทุนรวม`,
  ["link_manage"]: `จัดการลิงก์`,
  ["add_link"]: `เพิ่มลิงก์ใหม่`,
  ["link_reached_limit"]: `จำนวนลิงก์ถึงขีดจำกัดแล้ว`,
  ["copy_success"]: `คัดลอกสำเร็จ`,
  ["submit"]: `ยืนยัน`,
  ["cancel"]: `ยกเลิก`,
  ["download"]: `ดาวน์โหลด`,
  ["sub_domain"]: `ซับโดเมน`,
  ["sub_domain_ph"]: `กรุณากรอกซับโดเมนให้ถูกต้อง`,
  ["tag_name"]: `ชื่อแท็ก`,
  ["tag_name_ph"]: `กรุณากรอกชื่อแท็กให้ถูกต้อง`,
  ["link_status_0"]: `ไม่มีสถานะ`,
  ["link_status_1"]: `กำลังเริ่มต้นระบบ`,
  ["link_status_2"]: `มีผลแล้ว`,
  ["link_status_3"]: `สามารถลองใหม่ได้`,
  ["link_sttaus_4"]: `ไม่พร้อมใช้งาน`,
  ["month"]: `เดือน`,
  ["active_user_count"]: `จำนวนผู้ใช้งานที่ใช้งานอยู่`,
  ["product_fee_amount"]: `ค่าธรรมเนียมผลิตภัณฑ์`,
  ["dividend_ratio"]: `อัตราค่าธรรมเนียม`,
  ["dividend_amount"]: `คอมมิชชัน`,
  ["status"]: `สถานะ`,
  ["dividend_bill_status_0"]: `กำลังดำเนินการ`,
  ["dividend_bill_status_4"]: `รอการคำนวณยอด`,
  ["dividend_bill_status_9"]: `คำนวณยอดแล้ว`,
  ["month_phase_1"]: `ครึ่งเดือนแรก`,
  ["month_phase_2"]: `ครึ่งเดือนหลัง`,
  ["click_here"]: `คลิกที่นี่`,
  ["click_here_desc"]: `ติดต่อผู้ดูแลบัญชีของคุณเพื่อทำการถอน USDT`,
  ["available_commission"]: `สามารถรับเงินปันผลได้`,
  ["time"]: `วันที่`,
  ["affiliate_program"]: `แผนพันธมิตร`,
  ["active_user_desc"]: `คำอธิบายผู้ใช้งานที่ใช้งานอยู่`,
  ["payout_instructions"]: `คำอธิบายการคำนวณยอด`,
  ["payout_instructions_detail"]: `แต่ละเดือนปฏิทินจะมีการคำนวณยอด 2 ครั้ง</br>
รอบที่ 1: ตั้งแต่วันที่ 1 ถึงวันที่ 15 ของทุกเดือน (จ่ายวันที่ 20)</br>
รอบที่ 2: ตั้งแต่วันที่ 16 ถึงวันสุดท้ายของเดือน (จ่ายวันที่ 5 ของเดือนถัดไป)`,
  ["rules_detail"]: `1. เฉพาะผู้เล่นที่สมัครผ่านลิงก์แนะนำของตัวแทนเท่านั้น จึงจะมีสิทธิ์ได้รับเงินปันผล</br>
2. ตัวแทนทุกคนต้องร่วมรับผิดชอบค่าใช้จ่ายในการบริหารและค่าโปรโมชันที่เกิดขึ้นจริงจากสมาชิกของตน โดยค่าใช้จ่ายดังกล่าวจะถูกหักจากรอบกำไรถัดไป</br>
3. เฉพาะตัวแทนที่มีสถานะใช้งานจริงเท่านั้นจึงจะได้รับเงินปันผล (ต้องมีผู้ใช้งานจริงอย่างน้อย 5 คน ภายใน 2 สัปดาห์)</br>
4. หากผลกำไรติดลบของเดือนนั้นกลับมาเป็นบวก ตัวแทนจะไม่ได้รับเงินปันผล และยอดติดลบจะถูกยกยอดไปยังเดือนถัดไป</br>
5. ผู้ใช้หรือกลุ่มใดที่มีพฤติกรรมทำกำไรผิดปกติ (Arbitrage) จะถูกยกเลิกสิทธิ์รับเงินปันผล ในกรณีร้ายแรง บัญชีที่เกี่ยวข้องอาจถูกระงับหรือปิดโดยไม่แจ้งล่วงหน้า และจะไม่มีการคืนเงิน พร้อมทั้งถูกขึ้นบัญชีดำ</br>
6. เพื่อป้องกันการละเมิดนโยบายและโปรโมชัน ฝ่ายควบคุมความเสี่ยงจะตรวจสอบบัญชีตัวแทนทุกบัญชีอย่างเข้มงวด (รวมถึงชื่อ อีเมล หมายเลขโทรศัพท์ ฯลฯ) หากพบบัญชีใดมีส่วนเกี่ยวข้องกับการทำ Arbitrage หรือใช้โปรโมชันในทางที่ผิดร่วมกับตัวแทนอื่น ทางเราขอสงวนสิทธิ์ในการยกเลิกและยึดเงินคงเหลือของบัญชีตัวแทนและบัญชีที่เกี่ยวข้องทั้งหมดโดยไม่ต้องแจ้งให้ทราบล่วงหน้า</br>
7. ทางเราขอสงวนสิทธิ์ในการปฏิเสธหรือระงับบัญชีของตัวแทนพาร์ทเนอร์หรือสมาชิกใด ๆ ได้ทุกกรณี`,
  ["get_withdraw"]: `รับเงินปันผล`,
  ["commission_history"]: `ประวัติการปันผล`,
  ["link_capacity"]: `สามารถสร้างลิงก์ได้`,
  ["language"]: `ภาษา`,
  ["old_password"]: `รหัสผ่านเดิม`,
  ["old_password_ph"]: `กรุณากรอกรหัสผ่านเดิม`,
  ["new_password"]: `รหัสผ่านใหม่`,
  ["new_password_ph"]: `กรุณากรอกรหัสผ่านใหม่`,
  ["confirm_password"]: `ยืนยันรหัสผ่าน`,
  ["confirm_password_ph"]: `กรุณายืนยันรหัสผ่าน`,
  ["confirm_password_not_same"]: `รหัสยืนยันไม่ตรงกัน`,
  ["operation_success"]: `ดำเนินการสำเร็จ`,
  ["need_change_pwd_title"]: `บัญชีจำเป็นต้องเปลี่ยนรหัสผ่าน`,
  ["need_change_pwd_content"]: `บัญชีจำเป็นต้องเปลี่ยนรหัสผ่าน`,
  ["need_change_pwd_confirm"]: `ไปแก้ไข`,
  ["err_5001"]: `ภายในระบบผิดพลาด ล็อกไม่สำเร็จ`,
  ["err_5002"]: `ภายในระบบผิดพลาด เกิดความขัดแย้งในการล็อก`,
  ["err_5003"]: `ข้อมูลไม่ถูกต้อง`,
  ["err_6001"]: `ถูกแบน เข้าสู่ระบบไม่สำเร็จ`,
  ["err_6003"]: `ลิงก์ถึงขีดจำกัดแล้ว ไม่สามารถเพิ่มได้ และไม่สามารถสร้างลิงก์ซ้ำเดิมได้`,
  ["err_6004"]: `เกิดข้อขัดแย้งขณะสร้างลิงก์`,
  ["err_2003"]: `รหัสผ่านไม่ถูกต้อง`,
  ["err_2014"]: `ชื่อผู้ใช้ไม่ถูกต้อง`,
  ["err_1303"]: `กรอกรหัสผ่านเดิมผิด`,
  ["err_1308"]: `รหัสผ่านใหม่ซ้ำกับรหัสผ่านปัจจุบัน`,
  ["date_picker_today"]: `วันนี้`,
  ["date_picker_yesterday"]: `เมื่อวาน`,
  ["date_picker_7_days"]: `7 วันที่ผ่านมา`,
  ["date_picker_30_days"]: `30 วันที่ผ่านมา`,
  ["date_picker_this_month"]: `เดือนนี้`,
  ["select_date_range"]: `กรุณาเลือกวันที่`,
  ["date_picker_ok"]: `OK`,
  ["start_date"]: `วันที่เริ่มต้น`,
  ["end_date"]: `วันที่สิ้นสุด`,
  ["date_picker_year"]: `ปี`,
  ["date_picker_month"]: `เดือน`,
  ["date_picker_day"]: `วัน`,
}